// extracted by mini-css-extract-plugin
module.exports = {"page":"Login_page__ukQzG","row":"Login_row__35lmT","mainForm":"Login_mainForm__1hawh","title":"Login_title__1PdWF","logo":"Login_logo__3R5vb"};